import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { palette } from "styled-theme";
import { includes, propOr } from "ramda";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import PresentationMarkerIcon from "@mui/icons-material/StarBorder";

import { ICONS, MATERIAL_TYPES } from "~/constants/materials";

const StyledListItem = styled(ListItemButton)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  },
  height: "48px !important"
  /* cursor: pointer; */
}));

const PublisherAvatar = styled(({ isSelected, ...props }) => <Avatar {...props} />)`
  background-color: ${props => (props.isSelected ? palette("mbgreen", 0) : palette("grayscale", 2))} !important;
`;

const PresentationAvatar = styled(({ isSelected, ...props }) => <Avatar {...props} />)`
  background-color: ${props => (props.isSelected ? palette("prblue", 1) : palette("grayscale", 2))} !important;
`;

function notificationsLabel(count) {
  if (count === 0) {
    return "keine Inhalte";
  }
  if (count > 99) {
    return "mehr als 99 Inhalte";
  }
  return `${count} Inhalte`;
}

function RightSidebarMenuSmall({
  materialSizes,
  activeItems,
  isPresentationActive,
  isPresentationMaterialVisible,
  markedMaterialsSize,
  onItemToggle,
  onPresentationToggle
}) {
  console.log("materialSizes", materialSizes);
  return (
    <List>
      {MATERIAL_TYPES.filter(type => propOr(0, type, materialSizes) > 0).map(type => {
        const Icon = ICONS[type];

        return (
          <StyledListItem
            key={`material_filter_${type}`}
            onClick={onItemToggle(type)}
            aria-label={notificationsLabel(materialSizes[type])}
          >
            <ListItemAvatar>
              <Badge badgeContent={materialSizes[type]} color="error">
                <PublisherAvatar isSelected={includes(type, activeItems)}>
                  <Icon />
                </PublisherAvatar>
              </Badge>
            </ListItemAvatar>
          </StyledListItem>
        );
      })}
      {isPresentationActive && (
        <StyledListItem
          key={`presentation_material_filter`}
          onClick={onPresentationToggle}
          aria-label={notificationsLabel(markedMaterialsSize)}
        >
          <ListItemAvatar>
            <Badge badgeContent={markedMaterialsSize} color="error">
              <PresentationAvatar isSelected={isPresentationMaterialVisible && markedMaterialsSize > 0}>
                <PresentationMarkerIcon />
              </PresentationAvatar>
            </Badge>
          </ListItemAvatar>
        </StyledListItem>
      )}
    </List>
  );
}

RightSidebarMenuSmall.propTypes = {
  materialSizes: PropTypes.object,
  activeItems: PropTypes.array,
  isPresentationActive: PropTypes.bool.isRequired,
  isPresentationMaterialVisible: PropTypes.bool.isRequired,
  markedMaterialsSize: PropTypes.number,
  onItemToggle: PropTypes.func.isRequired,
  onPresentationToggle: PropTypes.func.isRequired
};

export default RightSidebarMenuSmall;
